package web.android.dev.pe.pages.articles

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*

@Page("/articles/talk-recommendations/en")
@Composable
fun TalkRecommendations_ENPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("articles/TalkRecommendations_EN.md", mapOf("title" to listOf("Tips for your presentation"), "author" to listOf("Android Dev Peru"), "description" to listOf("Recommendations for preparing and giving a technical talk."), "language" to listOf("en")))) {
        web.android.dev.pe.components.layout.MarkdownLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("tl-dr") }) {
                org.jetbrains.compose.web.dom.Text("TL;DR;")
            }
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.B {
                            org.jetbrains.compose.web.dom.Text("About your slides")
                        }
                        org.jetbrains.compose.web.dom.Text(":")
                    }
                    org.jetbrains.compose.web.dom.Ul {
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Be concise. Avoid excess text and graphics.")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Use a large font size. Very large.")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Contrast colors. Light > Dark (for presentations)")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Do not use screenshots of giant blocks of code, they are not visible.")
                        }
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.B {
                            org.jetbrains.compose.web.dom.Text("About your IDE")
                        }
                        org.jetbrains.compose.web.dom.Text(":")
                    }
                    org.jetbrains.compose.web.dom.Ul {
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Increase the font size.")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Activate \"Presentation mode\" if possible.")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Preferably, use ")
                            org.jetbrains.compose.web.dom.B {
                                org.jetbrains.compose.web.dom.Text("light")
                            }
                            org.jetbrains.compose.web.dom.Text(" mode.")
                        }
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.B {
                            org.jetbrains.compose.web.dom.Text("Ask us for feedback")
                        }
                        org.jetbrains.compose.web.dom.Text(". We will review your presentation and give you advice.")
                    }
                }
            }
            com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.TIP, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text(" In a face-to-face event, there will be people sitting several meters away and viewing the presentation from different angles. Therefore, it is important that the visual elements are clear and easy to read.")
                }
            }
            org.jetbrains.compose.web.dom.H2(attrs = { id("prepare-your-material") }) {
                org.jetbrains.compose.web.dom.Text("Prepare your material")
            }
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Identify your goal: What do you want the audience to learn or do after your talk?")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Identify your audience: Who are they? What level of knowledge do they have?")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Create a draft of your talk: What topics are you going to cover? In what order?")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Use bullet points as a summary.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("For a technical talk:")
                    org.jetbrains.compose.web.dom.Ul {
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Use a large font size. Very large.")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Em {
                                org.jetbrains.compose.web.dom.Text("Serif")
                            }
                            org.jetbrains.compose.web.dom.Text(" fonts are for papers, not for presentations.")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Use simple graphics and diagrams.")
                        }
                    }
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("Close your talk with a \"call to action\".")
                }
            }
            org.jetbrains.compose.web.dom.H2(attrs = { id("practice-your-presentation") }) {
                org.jetbrains.compose.web.dom.Text("Practice your presentation")
            }
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Time your talk")
                    }
                    org.jetbrains.compose.web.dom.Text(" taking into account the time assigned for your presentation.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Record yourself while rehearsing")
                    }
                    org.jetbrains.compose.web.dom.Text(" (preferably). You can see your mistakes and correct them.")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Prepare frequently asked questions")
                    }
                    org.jetbrains.compose.web.dom.Text(". Anticipate doubts.")
                }
            }
            com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
                org.jetbrains.compose.web.dom.P {
                    org.jetbrains.compose.web.dom.Text(" Remember: the audience is on your side. They are in the room for you. To listen to you. They want you to do well.")
                }
            }
            org.jetbrains.compose.web.dom.H2(attrs = { id("a-talk-on-how-to-give-a-technical-talk") }) {
                org.jetbrains.compose.web.dom.Text("\"A talk on how to give a technical talk\"")
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("If you want to delve into this topic, we recommend ")
                com.varabyte.kobweb.silk.components.navigation.Link("https://speakerdeck.com/jflavio11/una-charla-sobre-como-dar-una-charla-tecnica") {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("\"A talk on how to give a technical talk\"")
                    }
                }
                org.jetbrains.compose.web.dom.Text(" by one of our organizers, ")
                com.varabyte.kobweb.silk.components.navigation.Link("https://twitter.com/jflavio11") {
                    org.jetbrains.compose.web.dom.B {
                        org.jetbrains.compose.web.dom.Text("Jose Flavio Quispe")
                    }
                }
                org.jetbrains.compose.web.dom.Text(".")
            }
            web.android.dev.pe.pages.articles.components.TalkRecommendationsSlides()
        }
    }
}
